import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBsWY5g47bZNvF5Ua70xw_FTXwOHNTCnVk",
  authDomain: "e-challenge-ef311.firebaseapp.com",
  projectId: "e-challenge-ef311",
  storageBucket: "e-challenge-ef311.appspot.com",
  messagingSenderId: "59387764960",
  appId: "1:59387764960:web:ffaf7386f8ac41af12b085",
  measurementId: "G-ZD4HQJBZ6M",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
